export default class ScrollToTop {

	static Defaults() {
		return {
			fromHeight : 0
		};
	}

	constructor( options = {} ) {
		this.button = null;
		this.settings = Object.assign( {}, ScrollToTop.Defaults(), options );
		this.createElement();
		this.initClick();
		this.initScroll();
		this.initVisibility();
	}

	createElement() {
		this.button = document.createElement( 'button' );
		this.button.innerHTML = `<span class="dashicons dashicons-arrow-up-alt2"></span>`;
		this.button.style.display = 'none';
		this.button.classList.add( 'scroll-to-top' );
		document.body.appendChild( this.button );
	}

	initScroll() {
		window.addEventListener( 'scroll', e => {
			this.hide();
			this.initVisibility();
		} );
	}

	initVisibility() {
		if ( document.body.clientHeight <= window.innerHeight ) {
			this.hide();
			return;
		}

		if( window.pageYOffset > this.settings.fromHeight ){
			this.show();
		} else {
			this.hide();
		}
	}

	hide() {
		this.button.style.display = 'none';
	}

	show() {
		this.button.style.display = 'block';
	}

	initClick() {
		this.button.addEventListener( 'click', ( e ) => {
			e.preventDefault();
			ScrollToTop.scroll();
		} );
	}

	addMarkup() {

	}

	static scroll() {
		jQuery( 'html, body' ).animate( { scrollTop : 0 }, 500 );
		/*window.scrollTo( {
			top : 0,
			left : 0,
			behavior : 'smooth'
		} );*/
	}

}